import { get } from 'lodash';
import { Toast } from 'antd-mobile';
import { queryPreviousLuckyDrawListDXP, toReceivePrizesDXP } from '@/services/koiSeizesTreasure';

export default {
  namespace: 'koiSeizesTreasure',
  state: {
    preActivityList: [],
    activityList: {},
    useInfo: null,
    customerRaffleProfile: {},
    showRegiserModal: false, // 锦鲤夺宝展示未注册弹窗
  },
  reducers: {
    save(state, { payload }) {
      return { ...state, ...payload };
    },
  },
  effects: {
    *queryPreviousLuckyDrawListDXP({ payload }, { put, call }) {
      try {
        let resp = yield call(queryPreviousLuckyDrawListDXP, payload);
        resp = {
          ...resp,
          retCode: resp.resultCode,
          resultMsg: resp.resultMsg,
          data: {
            ...resp.data,
            activeLuckyDrawList:
              resp?.data?.ongoingGameList?.map(item => ({
                ...item,
                effDate: item.startDate,
                expDate: item.drawingDate,
                allParticipated: item.gameParticipantsNum,
                userParticipated: item.userParticipantsNum,
                koiRewardMemDtoList: item.rewardList,
                promotionName: item.gameName,
                enterDeadDate: item.participateDeadLine,
              })) || [],
            finishedLuckyDrawList:
              resp?.data?.upcomingGameList?.map(item => ({
                ...item,
                effDate: item.startDate,
                expDate: item.drawingDate,
                allParticipated: item.gameParticipantsNum,
                userParticipated: item.userParticipantsNum,
                koiRewardMemDtoList: item.rewardList,
                promotionName: item.gameName,
                enterDeadDate: item.participateDeadLine,
              })) || [],
            notStartLuckyDrawList:
              resp?.data?.endedGameList?.map(item => ({
                ...item,
                effDate: item.startDate,
                expDate: item.drawingDate,
                allParticipated: item.gameParticipantsNum,
                userParticipated: item.userParticipantsNum,
                koiRewardMemDtoList: item.rewardList,
                promotionName: item.gameName,
                enterDeadDate: item.participateDeadLine,
              })) || [],
          },
        };
        const data = get(resp, 'data') || {};
        delete data.ongoingGameList;
        delete data.endedGameList;
        delete data.upcomingGameList;
        const code = get(resp, 'retCode');
        const retDesc = get(resp, 'retDesc');
        let allList = [];
        (Object.values(data) || []).forEach(it => {
          allList = [...allList, ...(it || [])];
        });
        // 0表示成功
        if (code === '0') {
          // 过滤掉11的展示
          yield put({
            type: 'save',
            payload: {
              preActivityList: allList,
            },
          });
          return data || [];
        }
        Toast.show({ icon: 'fail', content: retDesc });
        return [];
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        return [];
      }
    },
    *toReceivePrizesDXP({ payload }, { call }) {
      let resp = yield call(toReceivePrizesDXP, payload);
      try {
        resp = {
          ...resp,
          retCode: resp.resultCode,
          retDesc: resp.resultMsg,
          data: {
            ...(resp?.data || {}),
            promotionMediaItemDtoList: resp?.data?.mediaItemList,
          },
        };
        const code = get(resp, 'retCode');
        const retDesc = get(resp, 'retDesc');
        // 0表示成功
        if (code === '0') {
          // 过滤掉11的展示
          // Toast.info(retDesc);
          return resp;
        }
        Toast.show({ icon: 'fail', content: retDesc });
        return {};
      } catch (e) {
        Toast.show({ icon: 'fail', content: e.Error });
        return {};
      }
    },
  },
};
